/* SPDX-License-Identifier: Apache-2.0 */
/* SPDX-FileCopyrightText: 2024 OKTET LTD */

export const DEFAULT_URI = 'memory://model';
export const DEFAULT_PROJECT_LABEL = 'No Project (Default)';
